module.exports = __webpack_public_path__ + "img/ic_hub_right_device.c387170a.svg";